export const rcphPricingVersions = [
  ['rcph-1.0-2024-11-19', { label: 'Version 1' }],
  ['rcph-1.1-2024-11-22', { label: 'Version 1.1 - MaJ CatNat' }],
  ['rcph-1.2-2024-12-12', { label: 'Version 1.2 - Fix premium overcharge' }],
  ['rcph-1.3-2025-04-09', { label: 'Version 1.3 - Fix RCP premium overcharge' }],
  ['rcph-1.4-2025-07-01', { label: 'Version 1.4 - Update fire tax' }],
  ['rcph-1.4.1-2025-09-01', { label: 'Version 1.4.1 - same as 1.4 but with quote V3' }],
  ['rcph-2.0-2025-09-01', { label: 'Version 2.0 - RCPH agora version' }],
  ['rcph-2.1-2026-01-15', { label: 'Version 2.1 - Updated activity config v3.1' }],
  ['rcph-2.2-2026-09-16', { label: 'Version 2.2 - Ouverture DROM-COM' }],
  ['rcph-2.3-2026-11-01', { label: 'Version 2.3 - Prime mini PJ 13,23 € HT' }],
] as const

export type RcphPricingVersion = (typeof rcphPricingVersions)[number][0]
